<template>
  <div>
    <panel title="Szablony wiadomości e-mail">
      <w-table
        entity-type="mail_template"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        @add="goToAddPage"
        @edit="goToEditPage($event.id)"
        @delete="showDeleteDialog($event.id)"
      />
    </panel>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';

const messages = {
  listError: Errors.MAIL_TEMPLATE_CANNOT_LIST,
  getError: Errors.MAIL_TEMPLATE_CANNOT_GET,
  added: Successes.MAIL_TEMPLATE_ADDED,
  addError: Errors.MAIL_TEMPLATE_ADD_ERROR,
  updated: Successes.MAIL_TEMPLATE_UPDATED,
  updateError: Errors.MAIL_TEMPLATE_UPDATE_ERROR,
  deleteConfirm: Successes.MAIL_TEMPLATE_CONFIRM_DELETE,
  deleted: Successes.MAIL_TEMPLATE_DELETED,
  deleteError: Errors.MAIL_TEMPLATE_DELETE_ERROR
};

// @vuese
// Lista szablonów wiadomości e-mail
// @group View
export default {
  components: { Panel, WTable },
  mixins: [listMixin('mailTemplate', messages)],
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID', width: '60px' },
      { name: 'name', displayName: 'Nazwa', sortable: true }
    ],
    actions: DEFAULT_TABLE_ACTIONS
  }),
  methods: {
    // @vuese
    // Przechodzi do strony dodawania nowej encji
    goToAddPage() {
      this.$router.push({ name: 'mailTemplateAdd' });
    },
    // @vuese
    // Przechodzi do strony edycji encji
    goToEditPage(id) {
      this.$router.push({ name: 'mailTemplateEdit', params: { mailTemplateId: id } });
    }
  }
};
</script>
